import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduzirMovimento = useReducedMotion();
  if (reduzirMovimento) {
    return <div className={className} data-id="element-107" data-mp="3gfxkaoso78gj">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15,
    margin: '0px 0px -10% 0px'
  }} transition={{
    duration: 0.3,
    ease: EASE,
    delay
  }} data-id="element-108" data-mp="2jrhwax57l75j">
      {children}
    </motion.div>;
}